import axios from "axios";
import { API_BASEURL, CONTENT_V1 } from "../utils/baseURL";
import { AuthResult } from "../enums/authResult";
import { Sort } from "../enums/sort";
import { BatchAddTag, EditVideo } from "../models/editDetails";
import { authHeader } from "../utils/headers";

export const search = async (
  pageSize: number,
  pageIndex: number,
  sortOrder: number,
  keyword?: string,
  types?: string,
  folderId?: string,
  sortField?: string,
) => {
  return await axios
    .get(
      `${API_BASEURL}${CONTENT_V1}insight/search/?c=${keyword}&p=${pageIndex}&s=${pageSize}&sf=${sortField}&so=${sortOrder}&types=${types}&folderId=${folderId}`,
      {
        headers: authHeader(),
      },
    )
    .catch((error) => {
      return error;
    });
};

export const getContentByID = async (contentId: string) => {
  return await axios
    .get(`${API_BASEURL}${CONTENT_V1}${contentId}`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const deleteContentByID = async (contentId: string) => {
  return await axios
    .delete(`${API_BASEURL}${CONTENT_V1}${contentId}`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const getPresignedUrl = async (
  s3BucketName: string,
  s3FileName: string,
) => {
  return await axios
    .get(
      `${API_BASEURL}${CONTENT_V1}get-s3-pre-signed-url/?bucket=${s3BucketName}&keyname=${s3FileName}`,
      {
        headers: {
          "Access-Control-Allow-Credentials": "true",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
          "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
          "Content-Length": "134",
          "Content-Type": "application/x-amz-json-1.1",
          Authorization: `Bearer ${sessionStorage.getItem(
            AuthResult.AccessToken,
          )}`,
        },
      },
    )
    .catch((error) => {
      return error;
    });
};

export const getThumbnailByVideoID = (videoId: string) => {
  return `${API_BASEURL}${CONTENT_V1}${videoId}/thumbnail`;
};

export const getVideoByID = async (videoId: string) => {
  return await axios
    .get(`${API_BASEURL}${CONTENT_V1}${videoId}/sasurl`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const manage = async (params: any) => {
  const sortOrder = params.sortOrder === Sort.Ascending ? 0 : 1;
  return await axios
    .get(
      `${API_BASEURL}${CONTENT_V1}search/?status=${params.status}&p=${params.pageIndex}&s=${params.pageSize}&sf=${params.sortKey}&so=${sortOrder}&cname=&fname=`,
      {
        headers: authHeader(),
      },
    )
    .catch((error) => {
      return error;
    });
};

export const retagVideo = async (videoIndexId: string) => {
  return await axios
    .put(`${API_BASEURL}${CONTENT_V1}${videoIndexId}/re-index`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const getVideoFromDB = async (videoId: string) => {
  return await axios
    .get(`${API_BASEURL}${CONTENT_V1}${videoId}/db`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const editVideo = async (request: EditVideo) => {
  return await axios
    .put(`${API_BASEURL}${CONTENT_V1}`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};

export const addBatchTag = async (request: BatchAddTag) => {
  return await axios
    .post(`${API_BASEURL}${CONTENT_V1}insight/batch-add`, request, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};


export const exportTranscript = async (videoId: string) => {
  return await axios
    .get(`${API_BASEURL}${CONTENT_V1}insight/transcripts?id=${videoId}`, {
      headers: authHeader(),  
    })
    .catch((error) => {
      return error;
    });
};
